<div class="c-gp-results-controls">
	<div class="content-wrapper">
		<div class="content-wrapper_tabs {{#if targets && targets.length === 1}}single-target{{/if}} {{#unless rawOutputMode}}table-mode{{/unless}}">
			{{#each targets:idx}}
				<div on-click="@this.handleTabSwitch(idx)"
					class="content-wrapper_tabs_tab {{#if idx === activeTargetIdx && rawOutputMode}}active{{/if}} {{#unless rawOutputMode}}disabled{{/unless}}">
					<span class="content-wrapper_tabs_tab_text">{{this}}</span>
					<span class="active-tab-bar"></span>
				</div>
			{{/each}}
		</div>

		<div class="content-wrapper_ctrls">
			<div class="content-wrapper_ctrls_switch" data-testid="results-display-switch">
				<input id="display-type"
					type="checkbox"
					checked="{{rawOutputMode}}"
					twoway="false"
					class="switch-input {{#unless rawOutputMode}}table{{/unless}}"
					on-click="@this.handleDisplayTypeInputClick(@event)"
					on-keydown="@this.handleDisplayTypeInputKeyDown(@event)">
				<label for="display-type" on-click="@this.handleDisplayTypeLabelClick(@event)">
					<span on-click="@this.handleDisplayTypeSwitch(true)">
						<img width="16" height="16" alt="" src="{{@shared.assetsHost}}/img/raw-output-icon{{#if rawOutputMode}}.active{{/if}}.svg">
						List
					</span>
					<span on-click="@this.handleDisplayTypeSwitch(false)">
						<img width="16" height="16" alt="" src="{{@shared.assetsHost}}/img/table-output-icon{{#unless rawOutputMode}}.active{{/unless}}.svg">
						Table
					</span>
				</label>
			</div>

			<button class="content-wrapper_ctrls_map-switch {{#if showMap}}content-wrapper_ctrls_map-switch--active{{/if}}"
				type="button"
				data-testid="map-switch"
				as-tooltip="showMap ? 'Hide map' : 'Show map'"
				aria-label="{{#if showMap}}Hide map{{else}}Show map{{/if}}"
				on-click="@this.set('originalShowMap', !showMap),@this.set('showMap', !showMap)">
				<img width="13" height="13" alt="" src="{{@shared.assetsHost}}/img/map-icon{{#if showMap}}.active{{/if}}.svg"/>
			</button>

			{{#if sortByOpts.length}}
				<div class="content-wrapper_ctrls_sort-options desktop-hidden dropdown">
					<div class="btn-group">
						<button type="button"
							class="dropdown-toggle content-wrapper_ctrls_btn"
							aria-label="Sort results"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false">
							<img width="18" height="18" alt="" src="{{@shared.assetsHost}}/img/sort-{{sortOrder}}.svg">
						</button>

						<ul role="listbox" class="dropdown-menu dropdown-menu-right">
							{{#each sortByOpts}}
								<li role="option"
									aria-selected="{{sortBy === this.value}}"
									on-click="@this.onSortOptionSelect(this.value)"
									class="dropdown-item {{#if sortBy === this.value}}selected{{/if}}"
								>
									{{this.name}}
									{{#if sortBy === this.value}}
										<img width="9" alt="{{sortOrder}}" src="{{@shared.assetsHost}}/img/sort-{{sortOrder}}-sm.svg">
									{{/if}}
								</li>
							{{/each}}
						</ul>
					</div>
				</div>
			{{/if}}

			<button class="content-wrapper_ctrls_collapse"
				type="button"
				disabled="{{!rawOutputMode}}"
				{{#if rawOutputMode}}
					as-tooltip="collapseTooltip"
					aria-label="{{collapseTooltip}}"
				{{/if}}
				on-click="allCollapsed ? expandOutput() : collapseOutput()"
			>
				{{#if allCollapsed}}
					<i class="fa fa-chevron-down"></i>
					<i class="fa fa-chevron-down"></i>
				{{else}}
					<i class="fa fa-chevron-up"></i>
					<i class="fa fa-chevron-up"></i>
				{{/if}}
			</button>
		</div>
	</div>
</div>

<script>
	const tooltip = require('../../assets/js/decorators/tooltip.js');

	component.exports = {
		decorators: {
			tooltip,
		},
		data () {
			return {
				collapseOutput: () => null,
				expandOutput: () => null,
				allCollapsed: false,
			};
		},
		computed: {
			collapseTooltip () {
				return this.get('allCollapsed') ? 'Expand all output' : 'Collapse all output';
			},
		},
		handleTabSwitch (idx) {
			if (this.get('rawOutputMode')) {
				this.set('activeTargetIdx', idx);
			}
		},
		handleDisplayTypeInputClick (event) {
			event.preventDefault();
			this.handleDisplayTypeSwitch(!this.get('rawOutputMode'));
		},
		handleDisplayTypeInputKeyDown (event) {
			if (event.key === ' ' || event.key === 'Enter') {
				event.preventDefault();
				this.handleDisplayTypeSwitch(!this.get('rawOutputMode'));
			}
		},
		handleDisplayTypeLabelClick (event) {
			event.preventDefault();
		},
		handleDisplayTypeSwitch (rawOutputMode) {
			this.set('rawOutputMode', rawOutputMode);
		},
		onSortOptionSelect (field) {
			if (this.get('sortBy') === field) {
				this.set('sortOrder', this.get('sortOrder') === 'asc' ? 'desc' : 'asc');
			} else {
				this.set('sortBy', field);
				this.set('sortOrder', 'asc');
			}

			return false;
		},
	};
</script>
